// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/categoria/:slug\",\"regex\":\"^/categoria/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/categoria/:slug/todos\",\"regex\":\"^/categoria/([^/]+)/todos$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/empresa/:slug\",\"regex\":\"^/empresa/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/evento/:slug\",\"regex\":\"^/evento/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/servico/:slug\",\"regex\":\"^/servico/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/conecta\"},{\"path\":\"/conecta/pendente\"},{\"path\":\"/minha-empresa\"},{\"path\":\"/minha-empresa/editar\"},{\"path\":\"/cadastro\"},{\"path\":\"/esqueci-senha\"},{\"path\":\"/login\"},{\"path\":\"/perfil\"},{\"path\":\"/categorias\"},{\"path\":\"/empresas\"},{\"path\":\"/eventos\"},{\"path\":\"/contato\"},{\"path\":\"/destaques\"},{\"path\":\"/exclusao-de-conta\"},{\"path\":\"/politica-privacidade\"},{\"path\":\"/termos-uso\"},{\"path\":\"/busca\"},{\"path\":\"/servicos\"},{\"path\":\"/sentry-example-page\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.8";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://368c79c1f34b988b65e77be77074b7f2@o4510319928934400.ingest.us.sentry.io/4510319929982976",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;